export const uk = {
    'NumberDefectIds.MUST_BE_NOT_OLDER': 'Выберите другой период и попробуйте снова',
    'NumberDefectIds.MUST_BE_NOT_OLDER-TITLE': 'Невозможно отобразить статистику',
    bannerAimingFailed: 'Что-то пошло не так. Попробуйте нацелиться еще раз позже.',
    bannerAimingSuccessful: 'Нацеливание прошло успешно. У Вас есть 10 минут, чтобы посмотреть объявление.',
    'cancel-survey': 'Вы действительно хотите отменить исследование Brand Lift?',
    'client-campaigns': 'Кампании клиента',
    'could-not-cancel-survey': 'В процессе отмены исследования произошла ошибка',
    'failed-to-update-data': 'Не удалось обновить данные. Показаны предыдущие значения',
    'fetch-moderation-reject-reasons-error': 'Не удалось получить причины отклонения. Попробуйте еще раз',
    'link-message-groups': 'Посмотреть',
    'mass-actions-server-error': 'Произошла ошибка. Перезагрузите страницу.',
    'my-campaigns': 'Мои кампании',
    operationError: 'Во время выполнения операции копирования произошла ошибка',
    'phrase-1': 'фразы',
    'phrase-2': 'фраз',
    'phrase-5': 'фраз',
    'popup-save-success': 'Изменения успешно сохранены',
    'search-and-replace-success': 'Замена произведена в {updatedTotalCount} из {selectedCount} {phraseWord}'
};
